import { HistoryItem } from '@bechtel/client-common';
import { Box, Heading } from '@bechtel/gds';
import { CommodityMilestoneActivity } from '@bechtel/types';
import { Trans } from '@lingui/macro';
import { get, map } from 'lodash';
import { FC } from 'react';
import { WeldActivityHistoryProps } from './types';

export const WeldActivityHistory: FC<WeldActivityHistoryProps> = ({ weld }) => {
  const milestonesActivityHistory: CommodityMilestoneActivity[] = get(weld, 'milestonesActivityHistory.items', []);
  const sortedMilestonesActivityHistory = milestonesActivityHistory
    ? [...milestonesActivityHistory]?.sort(
        (a, b) => new Date(b?.dateTime)?.getTime() - new Date(a?.dateTime)?.getTime() || b?.orderBy - a?.orderBy
      )
    : [];

  return (
    <>
      {sortedMilestonesActivityHistory && (
        <Box
          pl={{ sm: '700' }}
          pr={{ sm: '500' }}
          py={{ sm: '700' }}
          flexDirection={{ sm: 'column' }}
          style={{ overflowY: 'auto' }}
        >
          <Heading color="grey.1000" size="500" weight="600">
            <Trans>Activity History</Trans>
          </Heading>
          <Box flexDirection={{ sm: 'column' }} mt={{ sm: '600' }}>
            {map(sortedMilestonesActivityHistory, (activity, index: number) => (
              <HistoryItem
                isWeldCommodity={true}
                {...activity}
                last={sortedMilestonesActivityHistory.length === index + 1}
                workPackageTag={weld.workPackage?.tag}
                commodityName={weld.type.name}
                commodityTag={weld.tag}
              />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};
